import {UppyDashboardWrapper} from "../../../helpers/media-files/uppy/UppyDashboardWrapper";
import {getSingleInputElementByNameV3} from "../../../helpers/forms/formInputsHelpers";
import {clearFeedbacksByName} from "../../../helpers/forms";
import Axios from "axios";
import {loading, stopLoading} from "../../../helpers/loading";
import handleAjaxError from "../../../helpers/handleAjaxError";
import {handleAjaxSuccessNoRedirect} from "../../../helpers/ajax/handleAjaxSuccessNoRedirect";
import {scrollToElement} from "../../../helpers/scrolling/scrolling";

/**
 * Initialize Site Settings Index
 */
function initSiteSettingsIndex() {
	const settingsContainer = document.querySelector('.setting.site');
	if (!settingsContainer) {
		return;
	}

	const saveRoute = settingsContainer.dataset.route;

	const imageUploads = [];
	settingsContainer.querySelectorAll('.site-setting-image-container').forEach(container => {
		const uppy = new UppyDashboardWrapper(
			container.querySelector('.site-setting-image-upload'),
			{
				restrictions: {
					maxNumberOfFiles: 1,
					maxTotalFileSize: 1024 * 1024 * 20,
					allowedFileTypes: [
						'image/png',
						'image/jpeg',
						'image/gif',
					]
				},
			},
			{
				height: 'auto'
			}
		);
		imageUploads.push({
			name: container.dataset.name,
			uppy: uppy
		});
	});

	// Init tab select
	// noinspection JSValidateTypes
	/** @var {HTMLSelectElement} */
	const tabSelect = getSingleInputElementByNameV3(document.body, 'tab');

	if (tabSelect) {
		tabSelect.addEventListener('change', () => {
			handleTabChange();
		});
	}

	// Init save button
	const saveButton = document.querySelector('.store-settings-button');
	if (saveButton) {
		saveButton.addEventListener('click', () => {
			handleSave().then();
		});
	}

	/**
	 * Methods
	 */

	/**
	 * Handle tab change when the select element value changes
	 */
	function handleTabChange() {
		const selectedValue = tabSelect.selectedOptions[0].value;
		const relatedTab = $(`#${selectedValue}`);
		if (relatedTab.length) {
			relatedTab.tab('show');
		}
	}

	/**
	 * Handle save all settings
	 */
	async function handleSave() {
		const data = {};
		const inputs = settingsContainer.querySelectorAll('.site-setting-input');

		inputs.forEach(input => {
			if (input.classList.contains('site-setting-image-container')) {
				return;
			}

			if (input.type === 'checkbox') {
				data[input.name] = input.checked ? 1 : 0;
			} else {
				data[input.name] = input.value;
			}
		});

		// Handle images
		for (const upload of imageUploads) {
			await upload.uppy.checkAndPromptForOngoingUploads();
			data[upload.name] = upload.uppy.getFilesForSubmission();
		}

		clearFeedbacksByName(settingsContainer)

		loading();
		Axios.post(saveRoute, data)
			.then(response => {
				stopLoading()
				handleAjaxSuccessNoRedirect(response);
			})
			.catch(error => {
				handleAjaxError(error);
				// Display section with error if any
				const erroredField = settingsContainer.querySelector('.is-invalid');
				if (erroredField) {
					const relatedPane = erroredField.closest('.tab-pane');

					// Make visible
					if (relatedPane) {
						const paneId = relatedPane.getAttribute('id');
						$(`.nav-tabs a[href="#${paneId}"], .nav-pills a[href="#${paneId}"]`).tab('show');

						// Also update tabSelect if it exists
						if (tabSelect) {
							tabSelect.value = paneId.replace('pane', 'tab');
						}
					}

					// Wait a bit and scroll to it
					setTimeout(() => {
						scrollToElement(erroredField);
					}, 32)
				}
			})
			.finally(stopLoading);
	}
}

export {initSiteSettingsIndex};
